import type { ClientsListRow } from '../../app/contracts'

export interface ClientRef {
  client_code: string
  client_label: string
  segment_name: string | null
  service_name: string | null
}

export interface ChatContextSelection {
  client: ClientRef | null
}

export const EMPTY_SELECTION: ChatContextSelection = {
  client: null,
}

export function clientRefFromRow(row: ClientsListRow): ClientRef {
  return {
    client_code: row.client_code,
    client_label: row.client_label,
    segment_name: row.segment_name,
    service_name: row.service_name,
  }
}
